/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import {
    // ICategoryHierarchyViewProps,
    IRefineMenuViewProps,
    ISearchResultContainerViewProps,
    ISearchResultModalViewProps,
    ISortByViewProps,
    ITitleViewProps
} from '@msdyn365-commerce-modules/search-result-container';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React, { useEffect, useState } from 'react';
import { getDigitalNZDetailsAsync } from '../../actions/extensions/DataActionExtension.g';
import { ArtifactsListView } from './components/artifacts-list-view';
import { ExternalResourcesListView } from './components/external-resources-list.view';
import { CuratedCollectionList, ICuratedCollection } from './components/curated-collections-list-view';
import {
    IMoeSearchResultContainerProps,
    IMoeSearchResultContainerResources,
    siteName
} from './moe-search-result-container.props.autogenerated';
interface productListViewProps {
    productsListView?: React.ReactNode;
    ministryPagination?: React.ReactNode;
    ochPagination?: React.ReactNode;
    externalPagination?: React.ReactNode;
    ochProducts?: React.ReactNode;
    curatedCollectionData: ICuratedCollection[];
    localSearchBar?: React.ReactNode;
    resourceButton?: React.ReactNode;
    ochResourceButton?: React.ReactNode;
    allArtifactsButton?: React.ReactNode;
    enableListViewToggle?: boolean;
    expandCollapseAllButtons: React.ReactNode;
    preferredLanguageForError: string;
    preferredSearchSiteLanguage: string;
    preferredLanguageForButton: string;
}

const SearchResultContainerView: React.FC<ISearchResultContainerViewProps &
    productListViewProps &
    IMoeSearchResultContainerProps<{}>> = props => {
    const {
        SearchResultContainer,
        products,
        ochProducts,
        productsListView,
        localSearchBar,
        // ministryPagination,
        // ochPagination,
        // externalPagination,
        ProductsContainer,
        ProductSectionContainer,
        choiceSummary,
        isMobile,
        modalToggle,
        searchResultModal,
        TitleViewProps,
        refineMenu,
        //categoryHierarchy,
        sortByOptions,
        // CategoryNavContainer,
        RefineAndProductSectionContainer,
        // errorMessage,
        FeatureSearchContainer,
        similarLookProduct,
        context,
        data,
        curatedCollectionData,
        config,
        resourceButton,
        allArtifactsButton,
        enableListViewToggle,
        expandCollapseAllButtons,
        resources,
        preferredLanguageForError,
        preferredSearchSiteLanguage,
        preferredLanguageForButton
    } = props;

    // Variable declarations
    let searchString: any;
    if (context && context.request && context.request.query && context.request.query.q) {
        searchString = `"${context.request.query.q}"`;
    } else {
        searchString = data.category.result && data.category.result.Name;
    }
    searchString = (searchString as string).trim().replace(/'/g, '');

    // State declarations
    const [searchContent, setSearchContent] = useState('ministry');
    const [ministryState, setMinistryState] = useState('tileview');
    const [externalSiteData, setExternalSiteData] = useState<any[]>([]);
    const [externalSiteDataAttributes, setExternalSiteDataAttributes] = useState<any>();
    //const [isExternalResourcesLoading, setIsExternalResourcesLoading] = useState<boolean>(true);
    const artifactsDataAttributes = {};
    console.log(props.data.listPageState);
    //@ts-ignore
    const artifactsData: any[] = props.data?.listPageState?.result?.artifactsData;
    const toggleMinistryState = () => {
        if (ministryState === 'tileview') {
            setMinistryState('listview');
        } else {
            setMinistryState('tileview');
        }
    };
    const isSearchPage = props.data?.listPageState?.result?.pageType === 'Search' ? true : false;

    useEffect(() => {
        if (config.ochSearch) {
            setSearchContent('och');
        }
    }, []);

    const getExternalSiteResources = async () => {
        let extResourceData: any;
        setSearchContent('external');

        if (externalSiteData.length === 0) {
            try {
                extResourceData = await getDigitalNZDetailsAsync(
                    { callerContext: context.actionContext, bypassCache: 'get' },
                    searchString,
                    1
                );
            } catch (e) {
                console.log(e);
            }
            console.log('extResourceData before', extResourceData);
            console.table('ext res list before', externalSiteData);
            setExternalSiteData([...extResourceData?.search?.results]);
            setExternalSiteDataAttributes({
                page: extResourceData.search.page,
                per_page: extResourceData.search.per_page,
                result_count: extResourceData.search.result_count
            });

            console.log('extResourceData after', extResourceData);
            console.table('ext res list after', externalSiteData);

            //setIsExternalResourcesLoading(false);

            return;
        }
    };

    const showMoreExternalResources = async () => {
        let extResourceData: any;

        if (!externalSiteData) {
            extResourceData = await getDigitalNZDetailsAsync({ callerContext: context.actionContext, bypassCache: 'get' }, searchString, 1);
            setExternalSiteData([...extResourceData?.search?.results]);
            setExternalSiteDataAttributes({
                page: extResourceData.search.page,
                per_page: extResourceData.search.per_page,
                result_count: extResourceData.search.result_count
            });

            return;
        }

        if (externalSiteDataAttributes && externalSiteDataAttributes.page) {
            if (externalSiteData.length < externalSiteDataAttributes.result_count) {
                extResourceData = await getDigitalNZDetailsAsync(
                    { callerContext: context.actionContext, bypassCache: 'get' },
                    searchString,
                    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                    externalSiteDataAttributes.page + 1
                );
                setExternalSiteData([...externalSiteData, ...extResourceData?.search?.results]);
                setExternalSiteDataAttributes({
                    page: extResourceData.search.page,
                    per_page: extResourceData.search.per_page,
                    result_count: extResourceData.search.result_count
                });
            }

            return;
        }
    };

    const createSearchResultModal = (
        modalProps: ISearchResultModalViewProps,
        refineMenu: IRefineMenuViewProps,
        sortByDropDown: ISortByViewProps,
        isRecoSearchPage?: string,
        resources?: IMoeSearchResultContainerResources
    ): JSX.Element => {
        return React.cloneElement(
            modalProps.modal,
            {},
            modalProps.modalHeader,
            createModalBody(modalProps, refineMenu, sortByDropDown, isRecoSearchPage, resources),
            modalProps.modalFooter
        );
    };

    const createModalBody = (
        props: ISearchResultModalViewProps,
        refineMenu: IRefineMenuViewProps,
        sortByDropDown: ISortByViewProps,
        isRecoSearchPage?: string,
        resources?: IMoeSearchResultContainerResources
    ): JSX.Element | null => {
        if (sortByDropDown) {
            return React.cloneElement(
                props.modalBody,
                {},
                renderSort(sortByDropDown, isRecoSearchPage),
                renderRefiner(refineMenu, resources)
            );
        }
        return null;
    };

    const renderRefiner = (props: IRefineMenuViewProps, resources: IMoeSearchResultContainerResources | undefined): JSX.Element | null => {
        const { refiners, RefineMenuContainer, RefinerSectionContainer } = props;
        if (refiners) {
            return (
                <Node {...RefinerSectionContainer}>
                    <h3 className='ms-search-result-container__refiner-section-ttl'>
                        {preferredSearchSiteLanguage === 'maori' ? resources?.filterTextInMaori : resources?.filterText}
                    </h3>
                    {expandCollapseAllButtons}
                    <Node {...RefineMenuContainer}>
                        {refiners.map((submenu, index) => (
                            <React.Fragment key={index}>{submenu}</React.Fragment>
                        ))}
                    </Node>
                </Node>
            );
        } else {
            return (
                <div className='ms-search-result-container__refiner-section'>
                    <h3 className='ms-search-result-container__refiner-section-ttl'>
                        {preferredSearchSiteLanguage === 'maori' ? resources?.filterTextInMaori : resources?.filterText}
                    </h3>
                    <Node {...RefineMenuContainer}></Node>
                </div>
            );
        }
        // return null;
    };

    const renderSort = (props: ISortByViewProps, isRecoSearchPage?: string): JSX.Element | null => {
        const { SortingContainer, sortByDropDown } = props;
        if (sortByDropDown && !isRecoSearchPage) {
            return <Node {...SortingContainer}>{sortByDropDown}</Node>;
        }
        return null;
    };

    // const renderCategoryHierarchy = (props: ICategoryHierarchyViewProps): JSX.Element | null => {
    //     const { CategoryHierarchyContainer, categoryHierarchyList, categoryHierarchySeparator } = props;
    //     if (categoryHierarchyList) {
    //         return (
    //             <Node {...CategoryHierarchyContainer}>
    //                 {categoryHierarchyList.map((category, index) => (
    //                     <React.Fragment key={index}>
    //                         {category}
    //                         {categoryHierarchyList && categoryHierarchyList[index + 1] && categoryHierarchySeparator}
    //                     </React.Fragment>
    //                 ))}
    //             </Node>
    //         );
    //     }

    //     return null;
    // };

    const renderTitle = (props: ITitleViewProps): JSX.Element | null => {
        const { title, TitleContainer } = props;

        if (title) {
            return (
                <Node {...TitleContainer}>
                    <h2>
                        {title.titlePrefix}
                        {title.titleText}({title.titleCount})
                    </h2>
                </Node>
            );
        }
        return null;
    };

    const showMoreArtifacts = async () => {};

    const isRecoSearchPage = props.context.actionContext.requestContext.query?.recommendation;

    // function getArtifacts() {
    //     try {
    //         const context: any = { callerContext: props.context.actionContext };
    //         console.log('Get Props inside get Artifacts');
    //         // return getArtifactsByItemAsync(context, 'NZH30').then(result => result);
    //         return getArtifactsSearchResultsAsync(context, {
    //             Context: {
    //                 ChannelId: 68719479780,
    //                 CatalogId: 0
    //             },
    //             IncludeAttributes: true,
    //             SkipVariantExpansion: true,
    //             SearchCondition: 'history'
    //         }).then((result: any) => {
    //             return result;
    //         });
    //     } catch (err) {
    //         console.log(err);
    //         return;
    //     }
    // }

    // useEffect(() => {
    //     getArtifacts()?.then((artifacts: any) => {
    //         console.log('all Artifacts', artifacts);
    //     });
    // }, []);

    // void getArtifacts();
    const listViewBtnText = preferredSearchSiteLanguage === 'maori' ? resources.listViewButtonTextInMaori : resources.listViewButtonText;
    const tileViewBtnText = preferredSearchSiteLanguage === 'maori' ? resources.tileViewButtonTextInMaori : resources.tileViewButtonText;

    if (isMobile) {
        return (
            <Module {...SearchResultContainer}>
                {!config.ochSearch &&
                    props.data?.listPageState?.result?.pageType !== 'Search' &&
                    props.data?.listPageState?.result?.pageType !== 'Unknown' &&
                    localSearchBar}
                {/* {categoryHierarchy && renderCategoryHierarchy(categoryHierarchy)} */}
                {props.config.siteName !== siteName.kwr && renderTitle(TitleViewProps)}
                {props.config.siteName !== siteName.kwr && choiceSummary}
                {modalToggle}
                {createSearchResultModal(searchResultModal, refineMenu, sortByOptions, isRecoSearchPage, props.resources)}
                <Node {...FeatureSearchContainer}>{similarLookProduct}</Node>
                <div className='moe-tabs moe-tabs--underline'>
                    <div>
                        <button
                            onClick={() => setSearchContent('ministry')}
                            className={`moe-tabs__item moe-tabs__item-resources ${searchContent === 'ministry' ? 'active' : ''}`}
                        >
                            {preferredSearchSiteLanguage === 'maori' ? resources.resourcesTabTextInMaori : resources.resourcesTabText}
                        </button>
                        <>
                            {config.siteName === siteName.kwr && (
                                //{isSearchPage && props.data?.listPageState?.result?.pageType !== 'Unknown' && (
                                <button
                                    className={`moe-tabs__item ${searchContent === 'och' ? 'active' : ''}`}
                                    onClick={() => setSearchContent('och')}
                                >
                                    {preferredSearchSiteLanguage === 'maori' ? resources.ochTabTextInMaori : resources.ochTabText}
                                </button>
                            )}

                            <button
                                className={`moe-tabs__item ${searchContent === 'artifacts' ? 'active' : ''}`}
                                onClick={() => setSearchContent('artifacts')}
                            >
                                {preferredSearchSiteLanguage === 'maori' ? resources.artifactsTabTextInMaori : resources.artifactsTabText}
                            </button>
                            {config.siteName === siteName.kwr && (
                                <button
                                    onClick={() => setSearchContent('curate_collections')}
                                    className={`moe-tabs__item ${searchContent === 'curate_collections' ? 'active' : ''}`}
                                >
                                    {preferredSearchSiteLanguage === 'maori'
                                        ? resources.curatedCollectionTabTextInMaori
                                        : resources.curatedCollectionTabText}
                                </button>
                            )}
                            <button
                                className={`moe-tabs__item ${searchContent === 'external' ? 'active' : ''}`}
                                onClick={getExternalSiteResources}
                            >
                                {preferredSearchSiteLanguage === 'maori'
                                    ? resources.externalSitesTabTextInMaori
                                    : resources.externalSitesTabText}
                            </button>
                        </>
                    </div>
                    {props.config.siteName === siteName.kwr && (
                        <div className='moe-search-results-count'>
                            <span>{TitleViewProps.title.titleCount}</span>
                        </div>
                    )}
                </div>
                {searchContent === 'ministry' && !config.ochSearch && (
                    <>
                        {props.config.siteName !== siteName.kwr && enableListViewToggle && (
                            <div className='moe-listview__button-container'>
                                <span
                                    onClick={toggleMinistryState}
                                    className={`moe-listview__button-mobile ${
                                        ministryState === 'tileview' ? 'moe-listview__icon' : 'moe-tileview__icon'
                                    }`}
                                ></span>
                            </div>
                        )}
                        <Node {...ProductsContainer}>
                            {/* {errorMessage} */}
                            {ministryState === 'tileview' ? products : productsListView}
                        </Node>
                        {resourceButton}
                    </>
                )}

                {searchContent === 'och' && (
                    <>
                        <Node {...ProductsContainer}>
                            {/* {errorMessage} */}
                            {ochProducts}
                        </Node>
                        {/* {ochResourceButton} */}
                    </>
                )}

                {searchContent === 'artifacts' && (
                    <>
                        <Node className='moe-search-artifacts-resources__container'>
                            <ArtifactsListView
                                typeName='external'
                                id='ext-list-view'
                                context={props.context}
                                artifacts={artifactsData}
                                ArtifactsDataAttributes={artifactsDataAttributes}
                                className='moe-search-artifacts-resources'
                                data={artifactsData}
                                showMoreArtifacts={showMoreArtifacts}
                                resources={resources}
                                preferredLanguageForError={preferredLanguageForError}
                            />
                        </Node>
                        {allArtifactsButton}
                    </>
                )}

                {searchContent === 'curate_collections' && (
                    <>
                        <Node className='moe-search-curated-collections__container'>
                            <CuratedCollectionList
                                products={curatedCollectionData}
                                context={props.context}
                                id={''}
                                typeName={''}
                                data={curatedCollectionData}
                                resources={resources}
                                preferredLanguageForError={preferredLanguageForError}
                                preferredLanguageForButton={preferredLanguageForButton}
                            ></CuratedCollectionList>
                        </Node>
                    </>
                )}

                {searchContent === 'external' && (
                    <>
                        <Node className='moe-search-ext-resources__container'>
                            <ExternalResourcesListView
                                typeName='external'
                                id='ext-list-view'
                                context={props.context}
                                externalSiteData={externalSiteData}
                                //@ts-ignore
                                externalSiteDataAttributes={externalSiteDataAttributes}
                                className='moe-search-ext-resources'
                                data={externalSiteData}
                                showMoreExternalResources={showMoreExternalResources}
                                resources={resources}
                                preferredLanguageForError={preferredLanguageForError}
                                preferredLanguageForButton={preferredLanguageForButton}
                                //isExternalResourcesLoading={isExternalResourcesLoading}
                            />
                        </Node>
                    </>
                )}
            </Module>
        );
    }
    return (
        <Module {...SearchResultContainer}>
            {!config.ochSearch &&
                props.data?.listPageState?.result?.pageType !== 'Search' &&
                props.data?.listPageState?.result?.pageType !== 'Unknown' &&
                localSearchBar}
            {/* {categoryHierarchy && <Node {...CategoryNavContainer}>{renderCategoryHierarchy(categoryHierarchy)}</Node>} */}
            <Node {...RefineAndProductSectionContainer}>
                {config.siteName !== siteName.kwr && renderRefiner(refineMenu, props.resources)}
                <Node {...ProductSectionContainer}>
                    <Node {...FeatureSearchContainer}>{similarLookProduct}</Node>
                    <div className='ms-search-result-wrapper-title-choice-summary'>
                        {TitleViewProps && renderTitle(TitleViewProps)}
                        {choiceSummary}
                    </div>
                    <div className='ms-search-result-wrapper-sort-by-category'>
                        {sortByOptions && !isRecoSearchPage && renderSort(sortByOptions)}
                    </div>
                    <div
                        className={
                            config.siteName !== siteName.kwr
                                ? 'moe-tabs moe-tabs--underline'
                                : 'moe-tabs moe-tabs--underline kwr-tabs--underline'
                        }
                    >
                        <div>
                            {!config.ochSearch && (
                                <button
                                    onClick={() => setSearchContent('ministry')}
                                    className={`moe-tabs__item moe-tabs__item-resources ${searchContent === 'ministry' ? 'active' : ''}`}
                                >
                                    {preferredSearchSiteLanguage === 'maori'
                                        ? resources.resourcesTabTextInMaori
                                        : resources.resourcesTabText}
                                </button>
                            )}

                            {(isSearchPage || props.data?.listPageState?.result?.pageType === 'Unknown') && (
                                <button
                                    onClick={() => setSearchContent('och')}
                                    className={`moe-tabs__item ${searchContent === 'och' ? 'active' : ''}`}
                                >
                                    {preferredSearchSiteLanguage === 'maori' ? resources.ochTabTextInMaori : resources.ochTabText}
                                </button>
                            )}
                            <button
                                onClick={() => setSearchContent('artifacts')}
                                className={`moe-tabs__item ${searchContent === 'artifacts' ? 'active' : ''}`}
                            >
                                {preferredSearchSiteLanguage === 'maori' ? resources.artifactsTabTextInMaori : resources.artifactsTabText}
                            </button>
                            {config.siteName === siteName.kwr && (
                                <button
                                    onClick={() => setSearchContent('curate_collections')}
                                    className={`moe-tabs__item ${searchContent === 'curate_collections' ? 'active' : ''}`}
                                >
                                    {preferredSearchSiteLanguage === 'maori'
                                        ? resources.curatedCollectionTabTextInMaori
                                        : resources.curatedCollectionTabText}
                                </button>
                            )}
                            <button
                                onClick={getExternalSiteResources}
                                className={`moe-tabs__item ${searchContent === 'external' ? 'active' : ''}`}
                            >
                                {preferredSearchSiteLanguage === 'maori'
                                    ? resources.externalSitesTabTextInMaori
                                    : resources.externalSitesTabText}
                            </button>
                        </div>
                        {props.config.siteName === siteName.kwr && (
                            <div className='moe-search-results-count'>
                                <span>{TitleViewProps.title.titleCount}</span>
                            </div>
                        )}
                    </div>
                    {searchContent === 'ministry' && !config.ochSearch && (
                        <>
                            {enableListViewToggle && (
                                <div className='moe-listview__button-container'>
                                    <button
                                        onClick={toggleMinistryState}
                                        className='moe-btn moe-btn--primary-blue moe-listview__button-desktop'
                                    >
                                        <text>{ministryState === 'tileview' ? listViewBtnText : tileViewBtnText}</text>
                                    </button>
                                </div>
                            )}
                            <Node {...ProductsContainer}>
                                {/* {errorMessage} */}
                                {ministryState === 'tileview' ? products : productsListView}
                            </Node>
                            {resourceButton}
                        </>
                    )}

                    {searchContent === 'och' && (
                        <>
                            <Node {...ProductsContainer}>
                                {/* {errorMessage} */}
                                {ochProducts}
                            </Node>
                            {/* {ochResourceButton} */}
                        </>
                    )}

                    {searchContent === 'artifacts' && (
                        <>
                            <Node className='moe-search-artifacts-resources__container'>
                                <ArtifactsListView
                                    typeName='external'
                                    id='ext-list-view'
                                    context={props.context}
                                    artifacts={artifactsData}
                                    ArtifactsDataAttributes={artifactsDataAttributes}
                                    className='moe-search-artifacts-resources'
                                    data={artifactsData}
                                    showMoreArtifacts={showMoreArtifacts}
                                    resources={resources}
                                    preferredLanguageForError={preferredLanguageForError}
                                />
                            </Node>
                            {allArtifactsButton}
                        </>
                    )}

                    {searchContent === 'curate_collections' && (
                        <>
                            <Node className='moe-search-curated-collections__container'>
                                <CuratedCollectionList
                                    products={curatedCollectionData}
                                    context={props.context}
                                    id={''}
                                    typeName={''}
                                    data={curatedCollectionData}
                                    resources={resources}
                                    preferredLanguageForError={preferredLanguageForError}
                                    preferredLanguageForButton={preferredLanguageForButton}
                                ></CuratedCollectionList>
                            </Node>
                        </>
                    )}

                    {searchContent === 'external' && (
                        <>
                            <Node className='moe-search-ext-resources__container'>
                                <ExternalResourcesListView
                                    typeName='external'
                                    id='ext-list-view'
                                    context={props.context}
                                    externalSiteData={externalSiteData}
                                    //@ts-ignore
                                    externalSiteDataAttributes={externalSiteDataAttributes}
                                    className='moe-search-ext-resources'
                                    data={externalSiteData}
                                    showMoreExternalResources={showMoreExternalResources}
                                    resources={resources}
                                    preferredLanguageForError={preferredLanguageForError}
                                    preferredLanguageForButton={preferredLanguageForButton}
                                    //isExternalResourcesLoading={isExternalResourcesLoading}
                                />
                            </Node>
                        </>
                    )}
                </Node>
                {config.siteName === siteName.kwr && renderRefiner(refineMenu, props.resources)}
            </Node>
        </Module>
    );
};

export default SearchResultContainerView;
